import { NOTCH_DEPTH } from '../constants';

// Lets the page content scroll under the bar by the notch depth, so the
// transparent cutout reveals real content instead of the empty app background.
export const NOTCH_REVEAL_VAR = '--nav-notch-reveal';

export const setNotchReveal = (
  enabled: boolean,
  depth = NOTCH_DEPTH,
  root: HTMLElement = document.documentElement,
): void => {
  if (enabled) {
    root.style.setProperty(NOTCH_REVEAL_VAR, `${depth}px`);
  } else {
    root.style.removeProperty(NOTCH_REVEAL_VAR);
  }
};
